import { Box, Button, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    section: {
        // textAlign: 'center',
        width: '100%',
        boxShadow: '2px 5px ' + theme.palette.background.card,
        padding: theme.spacing(2),
        border: '1px solid ' + theme.palette.border.secondary,
        borderRadius: theme.spacing(0, 1, 1, 1)
    },
    box_text: {
        width: 'auto',
        padding: theme.spacing(1),
        background: theme.palette.primary.main,
        borderRadius: theme.spacing(1, 1, 0, 0),
        color: theme.palette.common.white,
        alignItems: 'center',
        display: 'flex',
    },
    actionRight: {

    },
    icon: {
        paddingRight: theme.spacing(2)
    }
}));

export default function CustomSection(props){
    const classes = useStyles();
    const {t} = useTranslation();
    const {title, children, icon, notMarginTop,height, actionRight} = props;

    return (
        <>
            <Grid xs={12} container item justify="center" alignItems="center">
                <Box item marginTop={notMarginTop ? 0 : 5} className={classes.box_text}>
                    {icon && <Grid item className={classes.icon}>{icon}</Grid>}
                    {title && <Typography variant="subtitle1">{title}</Typography>}
                </Box>
                <div style={{flex: 1}}></div>
                {actionRight && actionRight.show && <Box className={classes.actionRight}>
                    <Button variant='contained' size='small' onClick={actionRight.action ? actionRight.action : null}>{actionRight.title}</Button>
                </Box>}
            </Grid>
            <Grid xs={12} item className={classes.section} style={height ? {height: height} : undefined}>
                {children}
            </Grid>
        </>
    );
}